import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

export const useDebounceValue = <T>(value: T, delay = 450) => {
  const [debouncedVal, setDebouncedVal] = useState(value);
  const debouncedSetValue = useMemo(() => debounce(setDebouncedVal, delay), [delay]);

  useEffect(() => {
    debouncedSetValue(value);
  }, [value, debouncedSetValue]);

  useEffect(() => {
    return () => {
      debouncedSetValue.cancel();
    };
  }, [debouncedSetValue]);

  return debouncedVal;
};

// export function useDebounce<T>(value: T, wait = 400) {
//   const [debouncedValue, setDebouncedValue] = useState<T>(value);
//
//   const updateValue = useRef(
//     debounce(
//       (newValue: T) => {
//         setDebouncedValue(newValue);
//       },
//       wait,
//       {
//         leading: false,
//         trailing: true,
//       },
//     ),
//   ).current;
//
//   useEffect(() => {
//     updateValue(value);
//
//     return () => {
//       updateValue.cancel();
//     };
//   }, [value, updateValue]);
//
//   return debouncedValue;
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebounceFunc<T extends (...args: any[]) => any>(callback: T, wait = 400) {
  const debouncedFn = useMemo(
    () =>
      debounce(callback, wait, {
        leading: false,
        trailing: true,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);

  return debouncedFn;
}
